import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";

export const AuthField = ({ label, ...props }) => (
  <label className="block">
    <span className="text-sm font-semibold text-slate-700">{label}</span>
    <Input {...props} className="mt-1.5 h-14 rounded-xl border-2 border-slate-200 bg-white text-[17px] focus-visible:ring-0 focus-visible:border-slate-900" />
  </label>
);

export const AuthShell = ({ title, sub, children, footer }) => (
  <div className="grain min-h-screen">
    <div className="relative z-10 mx-auto flex min-h-screen max-w-md flex-col px-6 py-10">
      <Link to="/" className="font-display text-lg font-extrabold tracking-tight text-slate-900" data-testid="auth-brand-link">
        Squad<span className="text-[color:var(--brand)]">rum</span>
      </Link>
      <div className="flex flex-1 flex-col justify-center py-10">
        <h1 className="text-4xl font-extrabold tracking-tight text-slate-900">{title}</h1>
        <p className="mt-2 text-base text-slate-600">{sub}</p>
        <div className="mt-8">{children}</div>
        <div className="mt-6 text-sm text-slate-600">{footer}</div>
      </div>
    </div>
  </div>
);

export const SubmitButton = ({ loading, children, testId }) => (
  <button type="submit" disabled={loading} data-testid={testId}
    className="flex h-14 w-full items-center justify-center rounded-xl bg-slate-900 text-lg font-semibold text-white transition-[opacity,transform] active:scale-[0.98] disabled:opacity-50">
    {loading ? "Please wait..." : children}
  </button>
);
